/* esm.sh - d3-transition@3.0.1/src/transition/interpolate */
export * from "/*d3-transition@3.0.1/esnext/src/transition/interpolate.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/interpolate.mjs";
